import React, { useState, useContext } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
// Hooks
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
// Constants
import {
  SUCCESS,
  ERROR,
  INFORMATION_SAVED,
  AN_ERROR_OCCURRED,
  EDIT,
  OK,
  CANCEL,
  ENABLED,
  DISABLED,
  FUNRAISER_DISABLE,
  FUNDRAISER_HELP_TEXT_PRE,
  FUNDRAISER_HELP_TEXT_END,
} from '@client/definitions/constants';
import ReactLink from '@client/components/reactLink/ReactLink';
import { START_DATE, END_DATE } from '@client/definitions/api';
// Store
import { loadMyFundraisers } from '@client/redux/user';
import { putAndHandleFundraiserDates } from '@client/redux/fundraiser/fundraiserActions';
import { setFundraiserDraftDate } from '@client/helpers/draftFundraisers';
// Components
import { Dialog } from '@client/components/dialog/Dialog';
import { CurrentStatus } from '@client/components/currentStatus/CurrentStatus';
import { NotificationContext } from '@client/components/notificationProvider/NotificationProvider';
import FundraiserCardTargetsBox from '@client/containers/fundraiserCardTargetsBox/FundraiserCardTargetsBox';
// Styles
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './fundraiserCardLarge.scss';

export const FundraiserCardLarge = ({ fundraiser }) => {
  const [showDialog, setShowDialog] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isActive = getIn(fundraiser, 'isActive');
  const id = getIn(fundraiser, 'id');
  const title = getIn(fundraiser, 'title');
  const formattedStartDate = setFundraiserDraftDate();
  const formattedEndDate = setFundraiserDraftDate();
  const statusText = isActive ? ENABLED : DISABLED;

  const context = useContext(NotificationContext);

  const handleClick = (address) => {
    navigate(address);
  };

  const handleContinue = () => {
    setShowDialog(false);
    disableFundraiser();
  };

  const disableFundraiser = () => {
    const formData = new FormData();
    formData.append(START_DATE, formattedStartDate);
    formData.append(END_DATE, formattedEndDate);

    dispatch(putAndHandleFundraiserDates(formData, id))
      .then(() => {
        context.displayNotification(SUCCESS, INFORMATION_SAVED, 5000);
        dispatch(loadMyFundraisers());
      })
      .catch(() => {
        context.displayNotification(ERROR, AN_ERROR_OCCURRED, 5000);
      });
  };

  return (
    <div className={styles.fundraiserCardLarge}>
      <h3
        className={`${styleHelper.titleMdPrimary} ${styles.title}`}
        onClick={() => handleClick(`/insamling/${getIn(fundraiser, 'id')}/`)}
      >
        {getIn(fundraiser, 'title')}
      </h3>
      <div className={`${styleHelper.breadText} ${styles.cardSection}`}>
        {getIn(fundraiser, 'description')}
      </div>
      <FundraiserCardTargetsBox
        className={styles.cardSection}
        largeFont={true}
        fullWidthProgressBar={false}
        amountDonated={getIn(fundraiser, 'amountDonated')}
        targetAmount={getIn(fundraiser, 'targetAmount')}
      />
      <div className={`${styles.cardSection} ${styles.editButton}`}>
        <div className={styles.buttonRow}>
          <ReactLink
            className={`${styleHelper.btnPrimaryMd} ${styles.assetsBtn}`}
            to={`/assets/${getIn(fundraiser, 'slug')}`}
          >
            Gå till material
          </ReactLink>
          <button
            className={styleHelper.btnPrimaryMd}
            onClick={() =>
              handleClick(`/insamling/${getIn(fundraiser, 'id')}/?edit=true`)
            }
            fundraiser={fundraiser}
          >
            {EDIT}
          </button>
        </div>
        {isActive && (
          <button
            className={`${styleHelper.btnFlat} ${styles.endBtn}`}
            onClick={() => setShowDialog(true)}
          >
            {FUNRAISER_DISABLE}
          </button>
        )}
      </div>
      <Dialog
        showDialog={showDialog}
        handleContinue={handleContinue}
        handleAbort={() => setShowDialog(false)}
        title={FUNRAISER_DISABLE}
        text={`${FUNDRAISER_HELP_TEXT_PRE} **"${title}"**? ${FUNDRAISER_HELP_TEXT_END}`}
        textAbort={CANCEL}
        textContinue={OK}
      />
      <CurrentStatus
        className={styles.status}
        active={isActive}
        statusText={statusText}
      />
    </div>
  );
};

FundraiserCardLarge.propTypes = {
  fundraiser: ImmutablePropTypes.map,
};
